<template>
  <div class="pd20x flex1">
    <Loading v-if="loading"></Loading>
    <addQuestionBank :visible="visible" @close="visible = false" :data="currentItem" :type="currentType" @update="getData"></addQuestionBank>
    <div class="h100pct ofA">
      <div class="filter pd20x mb10x">
        <div>
          科目名称 : {{name}}
        </div>
        <div>
          <a-select style="width: 130px" v-model="downEnroll" @change="handleChange">
            <a-select-option value="single_choice">
              单选题
            </a-select-option>
            <a-select-option value="multiple_choice">
              多选题
            </a-select-option>
            <a-select-option value="jud_question">
              判断题
            </a-select-option>
            <a-select-option value="fill">
              填空题
            </a-select-option>
            <a-select-option value="answer">
              简答题
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div>
        <a-row>
          <a-col :span="22">
            <a-tabs @change="callback">
              <a-tab-pane v-for="(items, index) in bookList" :key="index" :tab="items.name"></a-tab-pane>
            </a-tabs>
          </a-col>
          <a-col :span="2">
            <a-button type="primary" ghost @click="showPapers">预览卷子</a-button>
          </a-col>
        </a-row>
      </div>
      <a-table
          :columns="columns"
          :data-source="result"
          :pagination="pagination"
          :scroll="{ x: 1300 }"
          :rowKey="'id'"
          @change="changePage"
      >
        <template v-for="(col, i) in ['consult', 'name']" :slot="col" slot-scope="text">
          <div :key="col" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            <a-tooltip>
              <template slot="title">
                {{ text }}
              </template>
              {{ text }}
            </a-tooltip>
          </div>
        </template>
        <template slot="status" slot-scope="text, record">
          <div v-if="record.status == 1">正常</div>
          <div v-if="record.status == 2" style="color: red">隐藏</div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-space>
            <a-button type="primary" ghost style="margin-right:10px" @click="editItem(record)">修改</a-button>
            <a-button type="primary" ghost style="margin-right:10px" @click="deleteItem(record.id)">删除</a-button>
          </a-space>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: '试题类型',
    dataIndex: 'typeName',
    scopedSlots: { customRender: 'typeName' },
    width: 120,
    align:'center'
  },{
    title: '题目',
    dataIndex: 'title',
    scopedSlots: { customRender: 'name' },
    width: 200,
    align:'center'
  },{
    title: '答案',
    dataIndex: 'consult',
    scopedSlots: { customRender: 'consult' },
    width: 200,
    align:'center'
  },{
    title: '页',
    dataIndex: 'ye',
    scopedSlots: { customRender: 'ye' },
    width: 100,
    align:'center'
  },{
    title: '段',
    dataIndex: 'duan',
    scopedSlots: { customRender: 'duan' },
    width: 100,
    align:'center'
  },{
    title: '行',
    dataIndex: 'hang',
    scopedSlots: { customRender: 'hang' },
    width: 100,
    align:'center'
  },{
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    width: 100,
    align:'center'
  }, {
    title: '操作',
    width: 140,
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
import * as http from '@/libs/analysis'
import { getQuestionBankList, delBankquestion } from '@/libs/api'
import addQuestionBank from '@/components/analysis/addQuestionBank'
import Loading from '@/components/loading'
import moment from 'moment'
export default {
  name: 'questionBank',
  components: {  Loading, addQuestionBank },
  data(){
    return{
      downEnroll: '添加单题',
      bookName: '',
      bookList: [],
      result: [],
      columns,
      visible: false,
      loading: true,
      currentType: 'single_choice',
      currentItem: [],
      name: '',
      classId : '',
      bookId: 0,
      total: 0,
      filter:{
        cate_id: 0,
        keywords:''
      },
      pagination:{
        page: 1,
        size: '15',
        pageSize: 15
      },
      colorList: ['pink', 'red', 'orange', 'green', 'cyan', 'blue', 'purple']
    }
  },
  mounted(){
    if (this.$route.query.bind_catid)
      this.filter.cate_id = this.$route.query.bind_catid;
    if (this.$route.query.name)
      this.name = this.$route.query.name;
    this.$nextTick(()=>{
      this.getBookList()
    })
  },
  methods:{
    moment,
    showPapers() {
      console.log(this.bookId)
      this.$router.push({path:'/analysis/showPaper', query: { bookId:this.bookId, name: this.name, bookName: this.bookName }})
    },
    callback(e) {
      console.log(e)
      this.bookId = this.bookList[e].id
      this.bookName = this.bookList[e].name
      this.getData()
    },
    getBookList(){
      this.loading = true;
      http.get_course_book({bind_id: this.filter.cate_id}).then(res=>{
        this.loading = false;
        this.bookList = res.data
        if(this.bookList.length > 0){
            this.bookId = this.bookList[0].id
            this.bookName = this.bookList[0].name
            this.getData()
        }
      }).catch(error=>{
        this.loading = false
        console.log(error)
      })
    },
    changePage({current}){
      this.pagination.page = current
      this.getData()
    },
    setShow(index , id){
      this.loading = true
      http.show_course_book({id:id}).then(res=>{
        this.loading = false;
        this.result[index]['show'] = !this.result[index]['show'];
      }).catch(error=>{
        this.loading = false
        console.log(error)
      })
    },
    getData(){
      this.result = [];
      this.loading = true;
      let request= {
        ...this.filter,...this.pagination,
        user_id:this.$store.state.userInfo.id,
        cate_id: this.filter.cate_id,
        bookId: this.bookId
      }
      getQuestionBankList(request).then(res=>{
        this.loading = false
        this.result = res.list
        this.total = res.total
      }).catch(error=>{
        this.loading = false
        console.log(error)
      })
    },
    handleChange(e){
      this.currentType = e;
      this.currentItem = [];
      this.visible = true;
      this.downEnroll = '添加单题'
    },
    onSelectChange(){

    },
    editItem(record){
      this.currentItem = record
      this.visible = true
    },
    deleteItem(id){
      let _this = this
      this.$confirm({
        title: '删除后不可恢复，确认删除吗?',
        centered: true,
        onOk() {
          delBankquestion({id}).then(res=>{
            _this.getData()
          },error=>{
            console.log(error)
          })
        },
      });
    },
    hideModal(){

    }
  }
}
</script>
<style lang="less" scoped>
</style>
